import { ref, watch, onMounted } from "vue";

type ThemeMode = "light" | "dark";

// const getInitialTheme = (): ThemeMode => {
// 	if (process.client && typeof window !== "undefined") {
// 		const saved = localStorage.getItem("theme") as ThemeMode | null;
// 		if (saved === "light" || saved === "dark") {
// 			return saved;
// 		}
// 		return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
// 	}

// 	return "light";
// };

const theme = ref<ThemeMode>("light");

export function useTheme() {
	// Sync with storage on mount in case localStorage changed before hydration.
	// onMounted(() => {
	// 	if (typeof window === "undefined") return;
	// 	const saved = localStorage.getItem("theme") as ThemeMode | null;
	// 	if (saved === "light" || saved === "dark") {
	// 		theme.value = saved;
	// 	}
	// });

	// Apply theme to <html>
	if (process.client) {
		watch(
			theme,
			(val) => {
				//document.documentElement.classList.toggle("dark", val === "dark");
				// localStorage.setItem("theme", val);
			},
			{ immediate: true }
		);
	}

	const toggleTheme = () => {
		theme.value = theme.value === "dark" ? "light" : "dark";
	};

	return {
		theme,
		toggleTheme,
	};
}
